// Mirrors backend CarCategoriesBrandsLoader source-of-truth: category_code →
// category_name pairs come straight from cars_small.json. Cars in Firestore
// store the code as a string (e.g. "1"), so the lookup keys match.
import carsData from "./cars.json";
import type { CarRow } from "./cars";

const RAW = carsData as readonly CarRow[];

const CATEGORY_NAMES: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const row of RAW) {
    const key = String(row.category_code);
    if (!map[key]) map[key] = row.category_name;
  }
  return map;
})();

export function getCarCategoryName(categoryId: string): string | null {
  return CATEGORY_NAMES[categoryId] ?? null;
}

export function getAllCarCategories(): { id: string; name: string }[] {
  return Object.entries(CATEGORY_NAMES)
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => Number(a.id) - Number(b.id));
}
